import { useState, useEffect, useCallback, useRef, useContext } from 'react';
import shuffle from 'lodash/shuffle';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { DEVIATION_SUGGESTIONS_I18N_KEYS, POSTS_SUGGESTIONS_I18N_KEYS, MAX_VISIBLE_SUGGESTIONS_DESKTOP, MAX_VISIBLE_SUGGESTIONS_MOBILE, } from '../constants';
export var useCommentSuggestions = function (type, editorApi, editorState) {
    var isMobile = useContext(MobileContext);
    // We have a set of pre-defined suggestions depending on `type`.
    // When this hook first runs we shuffle them and keep a reference to avoid repeating this process.
    var suggestionsRef = useRef(shuffle(type === 'deviation'
        ? DEVIATION_SUGGESTIONS_I18N_KEYS
        : type === 'posts'
            ? POSTS_SUGGESTIONS_I18N_KEYS
            : []));
    var _a = useState(), commentSuggestion = _a[0], setCommentSuggestion = _a[1];
    var isEditorEmpty = !editorState || editorState.isEmpty;
    /*
     ** Don't let user submit if:
     ** - editor is blank
     ** - they've selected a suggestion and haven't added any text
     */
    var submitValidator = useCallback(function (newState) {
        var editorText = newState.editorContent.getPlainText();
        return (!newState.isEmpty &&
            (!commentSuggestion || editorText !== commentSuggestion));
    }, [commentSuggestion]);
    // When suggestion is selected, reset editor with its content, making sure editor has been loaded
    useEffect(function () {
        if (commentSuggestion && editorApi) {
            // Even after the editor is "ready" we need to wait until editorState has been refreshed
            setTimeout(function () {
                editorApi.clearEditor(true, commentSuggestion);
            }, 10);
        }
    }, [editorApi, commentSuggestion]);
    // When editor content is cleared, we also clear the currently selected suggestion if there's any
    useEffect(function () {
        isEditorEmpty && setCommentSuggestion(undefined);
    }, [isEditorEmpty]);
    // Define number of visible suggestions, depending on platform and features.
    var maxVisible;
    if (isMobile) {
        maxVisible = MAX_VISIBLE_SUGGESTIONS_MOBILE;
    }
    else {
        maxVisible = MAX_VISIBLE_SUGGESTIONS_DESKTOP;
    }
    var onSuggestionSelect = function (suggestion) {
        return setCommentSuggestion(suggestion);
    };
    return {
        // if editor is unloaded and user selected a suggestion, force load
        forceEditorLoad: !editorApi && Boolean(commentSuggestion),
        submitValidator: submitValidator,
        suggestions: suggestionsRef.current,
        maxVisible: maxVisible,
        onSuggestionSelect: onSuggestionSelect,
    };
};
//# sourceMappingURL=useCommentSuggestions.js.map